import { useCurrentProject } from '@adsk/alloy-provider';
import { getDueDateTimeZone } from '../helpers/dueDateHelpers';
import { Rfi } from '../sdk';

export const useDueDateTimezone = (
  rfiCreatedAt: Rfi['createdAt'],
): { dueDateTimeZone: string | undefined } => {
  const currentProject = useCurrentProject();
  const dueDateTimeZone = getDueDateTimeZone(rfiCreatedAt, currentProject?.timezone);

  return { dueDateTimeZone };
};
